import { useState, useEffect } from 'react';
import { getNumContracts } from '../utils/users';

interface UseFetchNumContractsReturn {
  numContracts: number | null;
  isLoading: boolean;
  error: Error | null;
}

export const useFetchNumContracts = (strategy: string): UseFetchNumContractsReturn => {
  const [numContracts, setNumContracts] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchNumContracts = async () => {
      try {
        const num = await getNumContracts(strategy);
        setNumContracts(num);
      } catch (e) {
        setError(e as Error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNumContracts();
    const intervalId = setInterval(fetchNumContracts, 60000); // Adjust the interval as needed

    return () => clearInterval(intervalId);
  }, [strategy]);

  return { numContracts, isLoading, error };
};
